module.exports = __webpack_public_path__ + "static/media/voiture_03_thumb.dcfdbfb0.png";